import React from "react";
import Section from "../components/Section";

function Schedule() {
  const sectionStyle = {
    fontSize: "clamp(1.05rem, 1.8vw, 1.2rem)",
    lineHeight: "1.5",
    marginBottom: "15px",
  };

  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./schedule/Schedule_header.png"
        alt="Schedule"
        className="header-img"
      />

      <Section
        header={<h1 className="section-header">Topics and activities by week</h1>}
        content={
          <p>
            The following schedule serves as a rough outline for our class
            meetings this semester.
          </p>
        }
      />

      {/* Iframe Wrapper */}
      <div className="iframe-wrapper">
        <iframe
          src="https://docs.google.com/spreadsheets/d/1SdLkcWOgxaAd3Gz1RC8PFJ30GoADp8kbdPJfKJJi1RM/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"
          style={{ width: "100%", height: "800px", border: "none" }}
          title="Course Schedule"
        ></iframe>
      </div>
    </div>
  );
}

export default Schedule;
